<template>
	<v-container>
		<v-row>
			<v-col>
				<v-card class="pa-6">
					<v-card-title class="titleCard">DIAGNÓSTICO ACTUAL : Pneumonía adquirida en la comunidad ( J18.9 - Neumonía, microorganismo no especificado) </v-card-title>
					<v-data-table
					dense
					:headers="headerPrescripcion"
					:items="itemPrescripcion"    
					class="elevation-1"
					:footer-props="{
					'items-per-page-text':' '
				}"
				>

				<template v-slot:item.alerta="{ item }">


					<span :class="item.alertClass" class="vchip">

						{{ item.alerta }}

					</span>	

				</template>
				<template v-slot:item.descAlerta="{item}">
					<span  v-html="item.descAlerta"> {{ item.descAlerta }}</span>
				</template>

			</v-data-table>

		</v-card>
	</v-col>
</v-row>
</v-container>
</template>
<style>
.titleCard{
	background: green;
	color:white;
	margin-bottom:10px;
}
.vchip{
	border-radius: 16px;
	font-size: 14px;
	height: 32px;
	align-items: center;
	display: inline-flex;
	justify-content: center;
	max-width: 100%;
	
	width: 200px;
}
.red{
	color:white;
	background: red;
}
.bluelight{
	color:white;
	background: lightblue;
}
.orange{
	color: white;
	background: orange;
}
</style>
<script>
export default{
	data:()=>(
	{
		headerPrescripcion:[
		{text:'Código Nacional', value: 'cn', align: 'start',},
		{text:'Descripción de la presentación', value:'desc', },
		{text:'Posología', value:'posologia', },
		{text:'Frecuencia', value:'frecuencia', },
		{text:'Duración', value:'duracion', },
		{text:'Alerta', value:'alerta', },
		{text:'', value:'descAlerta', width:'250' },

		
		],
		itemPrescripcion:[
		{
			cn:'694761',
			desc: 'AMOXICILINA/ACIDO CLAVULANICO CINFA 875 mg/125 mg COMPRIMIDOS RECUBIERTOS CON PELICULA EFG, 30 comprimidos',
			posologia:'875MG/125MG 1 comprimido',
			frecuencia:'8h',
			duracion:'8-10 días',
			alerta:'Prescripción Bloqueada',
			alertaCode:'1',
			alertClass:"red",
			descAlerta: 'Contraindicación: alergia a la penicilina',

		},
		{
			cn:'706223',
			desc: 'LEVOFLOXACINO KRKA 500 MG COMPRIMIDOS RECUBIERTOS CON PELICULA EFG , 7 comprimidos',
			posologia:'500MG 1 comprimido',
			frecuencia:'8h',
			duracion:'7 días',
			alerta:'Alerta de Prescripción',
			alertaCode:'2',
			alertClass:"orange",
			descAlerta: 'La dosis excede la posología máxima (500mg/12h)',
			
		},
		{
			cn:'706223',
			desc: 'LEVOFLOXACINO KRKA 500 MG COMPRIMIDOS RECUBIERTOS CON PELICULA EFG , 7 comprimidos',
			posologia:'500mg 1 comprimido',
			frecuencia:'24h',
			duracion:'7 días',
			alerta:'Nota de seguridad',
			alertaCode:'3',
			alertClass:"bluelight", 
			descAlerta: '<p>MUH (FV), 14/2018 <a href="https://www.aemps.gob.es/informa/notasinformativas/medicamentosusohumano-3/seguridad-1/2018/ni_muh_fv-14-2018-quinolonas-fluoroquinolonas/" >https://www.aemps.gob.es/informa/notasinformativas/medicamentosusohumano-3/seguridad-1/2018/ni_muh_fv-14-2018-quinolonas-fluoroquinolonas/ </a> <br> Tras la evaluación realizada en el PRAC se ha concluido que las reacciones adversas musculoesqueléticas y del sistema nervioso, incapacitantes, de duración prolongada, y potencialmente irreversibles, afectan a todas las quinolonas y fluoroquinolonas, constituyendo un efecto de clase, por lo que se recomienda a los profesionales sanitarios: 	<ul> <li>		No utilizar quinolonas o fluroquinolonas en infecciones leves o autolimitadas salvo que otros antibióticos recomendados no puedan emplearse.</li><li> 			Indicar a los pacientes que interrumpan el tratamiento con este tipo de antibióticos y acudan al médico, en caso de que aparezcan síntomas relacionados con las reacciones adversas abajo descritas. </li>	<li>		Tener presente que los pacientes de edad avanzada, trasplantados o en tratamiento con corticoides presentan un mayor riesgo de sufrir lesiones tendinosas tras la administración de quinolonas y fluoroquinolonas.</li></p>MUH (FV), 12/2020 https://www.aemps.gob.es/informa/notasinformativas/medicamentosusohumano-3/seguridad-1/2020-seguridad-1/fluoroquinolonas-de-uso-sistemico-o-inhalado-riesgo-de-insuficiencia-valvular-y-regurgitacion-cardiaca/ Las fluoroquinolonas de administración sistémica o inhalada pueden aumentar el riesgo de insuficiencia valvular y regurgitación cardíaca.En pacientes con riesgo de desarrollar estas reacciones adversas, sólo se prescribirán antibióticos fluoroquinolónicos de administración sistémica o inhalada tras evaluar los riesgos potenciales frente a los beneficios esperados y una vez consideradas otras opciones terapéuticas.Los médicos deben informar a estos pacientes de los síntomas sugestivos de regurgitación o insuficiencia valvular cardíaca para que soliciten atención médica inmediata en caso de presentarlos.',

			
		}
		],

	}
	),
	methods:{
		getColor (value) {
			if(value=='1'){
				return 'red';
			}
			if(value=='2'){
				return 'orange';
			}
			if(value=='3'){
				return 'red';
			}

		},
	}
}


</script>
